import { Injectable, OnDestroy } from '@angular/core'
import { CookieConsentService } from '../cookie-consent/cookie-consent.service'
import { SubscriptionLike } from 'rxjs'
import { CookieVendorId } from '../cookie-consent/cookie-consent.fixtures'

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
    gtag?: (...args: unknown[]) => void
    gtmLoaded?: boolean
  }
}

@Injectable({
  providedIn: 'root',
})
export class GtmService implements OnDestroy {
  private subscriptions: SubscriptionLike[] = []
  private currentState?: boolean

  constructor(consentService: CookieConsentService) {
    window.dataLayer = window.dataLayer || []

    this.subscriptions.push(
      consentService.userPreferences.subscribe((userPreferences) => {
        if (!userPreferences[CookieVendorId.googleTagManager]) {
          if (this.currentState === true) {
            // War aktiv: Lade die Seite neu.
            window.location.reload()
          }
          return
        }

        window.gtag('consent', 'update', {
          consent_meta: userPreferences[CookieVendorId.meta]
            ? 'granted'
            : 'denied',
          consent_gads: userPreferences[CookieVendorId.googleAds]
            ? 'granted'
            : 'denied',
          consent_ga4: userPreferences[CookieVendorId.googleAnalytics]
            ? 'granted'
            : 'denied',
        })
        this.pushTag('consent_update')

        this.injectGTM()
      })
    )
  }

  private injectGTM() {
    if (this.currentState) {
      return
    }

    console.log('Injecting Google Tag Manager')

    this.pushTag('gtm.js', {
      'gtm.start': new Date().getTime(),
    })

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=GTM-KCDNKMBR`

    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.head.appendChild(script)
    }

    this.currentState = true
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe())
  }

  pushTag(event: string, args: Record<string, any> = {}) {
    console.log(`EVENT 🎉🥳🕺🙌 - [${event}] ${JSON.stringify(args)}`)
    window.dataLayer.push({
      event,
      ...args,
    })
  }
}
